#import "./StaffTrainingModuleSummaryFields.graphql"

query GetMyTrainingCourse($slug: String!) {
  myTrainingCourse(slug: $slug) {
    id
    slug
    title
    summary
    posterUrl
    category {
      id
      name
    }
    mandatory
    started
    status
    dueOn
    daysLeft
    moduleCount
    completeCount
    nextModuleSlug
    moduleSlug
    modules {
      ...StaffTrainingModuleSummaryFields
    }
  }
}
